/**
 * The Connect URL an operator types into a charger: the public OCPP
 * websocket base for THIS stage plus the charger identity.
 *
 * The base comes from VITE_OCPP_PUBLIC_WS_URL (infra/sst.config.ts admin
 * environment: wss://ocpp.stg.evinitiative.com on staging,
 * wss://ocpp.evinitiative.com on prod), the same value the api exposes to
 * the SP install wizard as OCPP_PUBLIC_WS_URL. Before 2026-09-16 the
 * charger page printed a `ws://YOUR_HOST:9000/` placeholder here, which
 * an operator standing at a unit could not use.
 *
 * The fallback is the staging host on purpose: a bundle built without
 * the variable is a staging/CI bundle, and pointing a real charger at
 * staging is recoverable; a placeholder is not.
 */
const FALLBACK_BASE = 'wss://ocpp.stg.evinitiative.com';

export function ocppPublicWsBase(): string {
  const raw = (import.meta.env['VITE_OCPP_PUBLIC_WS_URL'] as string | undefined)?.trim();
  const base = raw && raw.length > 0 ? raw : FALLBACK_BASE;
  return base.replace(/\/+$/, '');
}

export function ocppConnectUrl(identity: string): string {
  return `${ocppPublicWsBase()}/${identity}`;
}
